import { ResponseStatus } from '../../../../../FrontEndReact/src/Core/Types/base';
import { callBizpart } from '../../../../../Js/React/Services/common';
import { PreRegisterInfo } from '../Types/register';

const apiPath = 'api/bigregister/';

export const getPreRegistrationInfo = async (email: string) => {
	const res = await callBizpart<PreRegisterInfo>(`${apiPath}GetPreRegistrationInfo?email=${encodeURIComponent(email)}`);
	return res;
};

export const preRegistration = async (email: string, unitId: number) => {
	const res = await callBizpart<ResponseStatus>(`${apiPath}PreRegisterUser`, { Email: email, UnitId: unitId });
	return res;
};
